<template>
  <v-typeahead-bootstrap
    v-model="search"
    @hit="modelValue = $event"
    :serializer="serializerItems"
    :data="listMandatos"
    :class="[stateClass, classToDisabledStatus]"
    :size="size"
    :placeholder="placeholder"
    class="form-control form-control-custom form-bag-select"
    :disabled="isDisabled"
    show-on-focus
    v-bind="$props"
  />
</template>
<script>
import { mapActions } from "vuex";
import VTypeaheadBootstrap from "vue-typeahead-bootstrap";
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";
import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";
import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import moment from "moment";
import { find } from "lodash";

export default {
  name: "SelectItemMandato",
  mixins: [formControlMixin, formStateMixin],
  model: {
    prop: "value",
    event: "input",
  },
  props: makePropsConfigurable(
    sortKeys({
      ...formStateProps,
      ...formControlProps,
      value: null,
      return_object: false,
      placeholder: {
        type: String,
        default: "Selecione um mandato",
      },
      conselhoId: {
        type: Number,
        default: null,
      },
      type: {
        type: String,
        validator: (value) =>
          ["conselheiro", "mesa-diretora", "ambos"].includes(value),
        default: "ambos",
      },
      start: {
        type: String,
      },
      end: {
        type: String,
      },
      hidden: {
        type: Number,
      },
      emitValue: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: "md",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      addNullValue: {
        type: Boolean,
        default: false,
      },
    })
  ),
  components: {
    VTypeaheadBootstrap,
  },
  data() {
    return {
      search: "",
      items: [],
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.emitValue) {
          this.$emit("input", value);
          return;
        }
        this.$emit("input", value.id);
      },
    },
    isDisabled() {
      if (!this.disabled) {
        return !this.hasListMandatos;
      }
      return this.disabled;
    },
    classToDisabledStatus() {
      return {
        "bg-secondary text-secondary border-secondary cursor-disabled":
          this.isDisabled,
      };
    },
    listMandatos() {
      const listItems = (this.items || []).slice();

      const toYear = (date) => moment(date).year();
      const formatItem = (item) => ({
        label: `${toYear(item.gestao_ini)}-${toYear(item.gestao_fim)}`,
        id: item.id,
      });
      let items = listItems.map(formatItem);

      if (this.addNullValue) {
        items.unshift({
          id: null,
          label: "--",
        });
      }
      return items;
    },
    hasListMandatos() {
      const list = this.listMandatos;
      return list.length > 0;
    },
  },
  methods: {
    ...mapActions("conselheiros", ["ActionGetAllMandatos"]),
    async loadData() {
      try {
        const payload = {
          conselho_id: this.conselhoId,
        };
        if (["conselheiro", "mesa-diretora"].includes(this.type)) {
          payload.tipo = this.type;
        }
        const result = await this.ActionGetAllMandatos(payload);
        this.items = result;

        if (!this.hasListMandatos) {
          this.$notify({
            message: "O conselho selecionado não possui mandatos válidos",
            type: "info",
            icon: "exclamation",
          });
        }
      } catch (error) {
        this.$notify({
          message: "Erro ao listar mandatos",
          type: "danger",
          icon: "exclamation",
        });
      }
    },
    setById(id) {
      const selectedItem = find(this.items, { id });
      if (selectedItem) {
        this.search = selectedItem.nome;
        this.value = selectedItem;
      }
    },
    serializerItems(item) {
      return item.label;
    },
  },
  watch: {
    conselhoId: {
      handler(value) {
        if (!value) {
          return;
        }
        this.loadData();
      },
    },
    value: function (id, old) {
      if (id == null) {
        this.search = "";
      }
    },
  },
  created() {
    if (!this.conselhoId) {
      return;
    }

    this.loadData();
    if (this.value) {
      this.setById(this.value);
    }
  },
};
</script>
<style scoped lang="scss">
::v-deep .input-group {
  cursor: not-allowed;
}
</style>
